import {Component, OnInit, ViewEncapsulation} from "@angular/core";

import {MainService} from "src/app/Services/service.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation} from "ngx-gallery";
import {DTOAdvertisementEx} from "src/app/api/LocalModels";
import {isNumber} from "util";
import {ConversationService} from "../../Services/conversationService";
import {MatDialog} from "@angular/material/dialog";
import {SendConversationMessageComponent} from "../../Components/send-message/send-conversation-message.component";
import {DTOAdvertisement} from "../../api/WickedApiClient";
import {CompareVersionsComponent} from "../../Cms/compare-versions/compare-versions.component";
import {environment} from "src/environments/environment";

@Component({
  selector: "app-adv-detail",
  templateUrl: "./adv-detail.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./adv-detail.component.scss"]
})
export class AdvDetailComponent implements OnInit {

  public isPremium: boolean = false;
  public existedConversationId: number = -1;
  public watchingByAuthor: boolean = false;

  public perPage: number = 24; //count convs per page 0 is for all
  public page: number = 0;

  constructor(public route: ActivatedRoute, public service: MainService, public conversationService: ConversationService, public matDialog: MatDialog, public router: Router) {
    this.isPremium = this.service.userService.isPremium();
    this.route.queryParams.subscribe(params => {
      let paramPage = (isNaN(params['page']) ? 1 : params['page']);
      paramPage = paramPage <= 0 ? 1 : paramPage;
      this.page = Number(paramPage) - 1;
      let paramPerPage = (isNaN(params['perPage']) ? 24 : params['perPage']);
      if (paramPerPage) this.perPage = Number(paramPerPage);
      else this.perPage = 24;
    });
  }

  public get Location() {
    if(!this.advParam.isDemo) {
      return (this.advParam.subRegionName || this.advParam.regionShortName) ? (this.advParam.subRegionName + (this.advParam.regionShortName ? (", " + this.advParam.regionShortName) : "")) : "";
    } else {
      const subRegionName = this.advParam.subRegionName;
      if(subRegionName && subRegionName.trim() != "") {
        return subRegionName + (this.advParam.regionShortName ? (", " + this.advParam.regionShortName) : "");
      }
      else {
        let currentLocation = this.service.cookieService.get("current_location_text");
        if(currentLocation) {
          return currentLocation.split(",")[0]
        }
      }

      // //demo ad - calculate location based current user location
      // const currentRegionId = this.service.advService.searchDataStandard.currentSearchRule.regionId;
      // const currentSubRegionId = this.service.advService.searchDataStandard.currentSearchRule.subRegionId;
      //
      // if (currentRegionId && currentSubRegionId) {
      //   const Location = this.service.advService.getSubRegionNameById(currentRegionId, currentSubRegionId);
      //   return Location ? Location.name : '';
      // } else {
      //   let currentLocation = this.service.cookieService.get("current_location_text");
      //   if (currentLocation) {
      //     return currentLocation.split(",")[0]
      //   } else {
      //     return '';
      //   }
      // }
    }

  }

  public _advParam: DTOAdvertisementEx;

  get advParam(): DTOAdvertisementEx {
    return this._advParam;
  }

  set advParam(value: DTOAdvertisementEx) {
    this._advParam = value;
  }

  public lat: number;
  public lng: number;

  public galleryOptions: NgxGalleryOptions[] = [
    {
      thumbnailsColumns: 4,
      width: "100%",
      height: "535px",
      imageSize: 'Contain',
      imageAnimation: NgxGalleryAnimation.Slide
    }
  ];

  public galleryImages: NgxGalleryImage[] = [];
  public canShowMap: boolean = false;

  public get dateStart(): string {
    return this.advParam && this.advParam.dateStart ? this.advParam.dateStart.format("MM/DD/YYYY") : "";
  }

  public get isImageSet(): boolean {
    return this.advParam && this.advParam.images && this.advParam.images.length > 0;
  }

  get isUserAdmin(): boolean {
    return this.service.userService.isAdmin();
  }

  get advCode(): string {
    return this.route.snapshot.paramMap.get("code");
  }


  ngOnInit(): void {
    window.scrollTo(0, 0)
    var code = this.route.snapshot.paramMap.get("code");

    var usersearch = this.route.snapshot.paramMap.get("usersearch");


    this.advParam = this.service.advService.searchDataStandard.resultList.filter(v => {
      return v.advertisementId == Number(code);
    })[0];

    if(!this.advParam) {
      this.advParam = this.service.advService.searchDataUserAdv.resultList.filter(v => {
        return v.advertisementId == Number(code);
      })[0];
    } else {
      this.markCurrentAdvertisementAsSeenIfNecessary(this.advParam);
    }


    if(!this.advParam && isNumber(Number(code))) {
      this.advParam = AdvDetailComponent.initEmptyAdvMock();//empty mock for avoid errors if null
      var conversationKey = this.route.snapshot.paramMap.get("conversationKey");
      this.service.advService.get(Number(code), conversationKey).then(r => {
        if(r.adveristments && r.adveristments.length > 0) {
          this.advParam = new DTOAdvertisementEx(r.adveristments[0]);
          this.afterAdvLoad();
        } else {
          this.service.route.navigate([""]).then(() => {
            this.service.showWarning("Adveristment not found");
          });
        }
      });
      const dtoAdvertisementEx = this.service.advService.searchDataUserAdv.resultList.filter(v => {
        return v.advertisementId == Number(code);
      })[0];
      if(dtoAdvertisementEx != null) {
        this.advParam = dtoAdvertisementEx;
      } else {
        this.advParam = AdvDetailComponent.initEmptyAdvMock();
      }
    } else {
      this.afterAdvLoad();
    }
  }

  public static initEmptyAdvMock(): DTOAdvertisementEx {
    const mock = new DTOAdvertisementEx();
    mock.title = "";
    mock.content = "";
    mock.images = [];

    return mock;

  }

  markCurrentAdvertisementAsSeenIfNecessary(adv: DTOAdvertisement) {
    if(this.service.userService.isAuthenticated() && (this.service.userService.isDemo() || this.service.userService.isAdmin()) && adv.isDemo == false && (adv.seen == false || adv.seenAdmin == false)) {
      this.service.advService.markAdvertisementAsSeen(adv.advertisementId, this.isUserAdmin).then(res => {
        this.advParam.seen = true;
        let index = this.service.advService.searchDataStandard.resultList.findIndex(i => i.advertisementId == adv.advertisementId);
        if(index > -1) {
          if(this.service.userService.isDemo()) {
            this.service.advService.searchDataStandard.resultList[index].seen = true;
          }

          if(this.service.userService.isAdmin()) {
            this.service.advService.searchDataStandard.resultList[index].seenAdmin = true;
          }


        }


      }).catch(err =>
        this.service.showError(err)
      )
    }
  }

  afterAdvLoad() {
    if(this.advParam) {

      const currentUserId = this.service.userService.getUserId();
      if(this.advParam.userId == currentUserId) {
        this.watchingByAuthor = true;
      }

      this.conversationService.getActiveConversationId(this.advParam.advertisementId).toPromise().then(id => {
        this.existedConversationId = id;
      });

      this.markCurrentAdvertisementAsSeenIfNecessary(this.advParam);

      this.advParam.images = this.advParam.images || [];

      this.advParam.images.sort((a, b) => {
        return a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0;
      });


      this.advParam.images.forEach(v => {
        this.galleryImages.push({
          small: `${environment.apiBaseUrl}/FileGet/${v.fileName}/139x125`,
          medium: `${environment.apiBaseUrl}/FileGet/${v.fileName}/800x600`,
          big: `${environment.apiBaseUrl}/FileGet/${v.fileName}`
        });
      });

      if(this.advParam.location && this.advParam.location != "") {
        const location = this.advParam.location.split("/").map(str => parseFloat(str));
        if(location.length == 2) {
          this.canShowMap = true;
          this.lat = location[0];
          this.lng = location[1];
        }

      }
      if(!this.canShowMap) {
        this.service.advService
          .getLocationDataByZipCode(this.advParam.zipCode)
          .toPromise()
          .then((v: any) => {
            try {
              if(v.results[0].geometry.location.lat) {
                this.canShowMap = true;
                this.lat = v.results[0].geometry.location.lat;
                this.lng = v.results[0].geometry.location.lng;
              }
            } catch(e) {
              console.log(e);
            }
          });
      }

    }
  }

  //TODO dac chyba messagecomponent typ jako send-conversation-message lub textinput-bar
  sendInitialConversationMessage(messageComponent) {
    if(!this.service.userService.isAuthenticated()) {

      this.service.showLogin();

    } else {
      const messageParams = messageComponent.prepareMessageParams();
      messageComponent.submitStart();
      this.conversationService.sendStartingConversationMessage(
        this.service.userService.getUserId(),
        this.advParam.userId,
        messageParams.nick,
        messageParams.content,
        this.advParam.advertisementId,
        messageParams.images,
        this.advParam.isDemo ? this.advParam.subRegionName : null,
        this.advParam.isDemo ? this.advParam.regionShortName : null,
        this.advParam.isDemo ? this.advParam.dateStart : null
      ).then(result => {
        messageComponent.submitFinished();
        let thanksInfo = this.service.showInformation("Your message has been sent");
        setTimeout(() => {
          thanksInfo.dismiss();
          this.router.navigate(['/conversations']);
        }, 2000);
        messageComponent.clear();
      }
      ).catch(res => {
        messageComponent.submitFinished();
        this.service.showError(res)
      })
    }
  }

  public resolveAdvTitle(advParam: DTOAdvertisementEx) {
    if(!advParam) {
      return ""
    } else return advParam.title || '';
  }

  ageIsValid() {
    return this.advParam && this.advParam.age && this.advParam.age.trim() != '';
  }
}
